<template>
    <transition name="modal-fade">
        <div class="inset-0 z-max modal-window transition fixed opacity-1" v-if="show">
            <div class="shadow bg-black opacity-50 w-full h-full" @click="closeMethod"></div>
            <div class="window bg-white rounded min-h-56 left-0 right-0 mx-auto transition fixed opacity-1 flex flex-col"
                 :style="{height: fullHeight ? `calc(100% - 20rem)` : ''}"
                 :class="modalSize">
                <div class="flex px-4 py-3 items-center">
                    <h2 class="text-lg">{{ !isCorrectPIN ? "Zadajte PIN" : modalTitle }}</h2>
                    <font-awesome v-if="isDismissible" @click="closeMethod" class="ml-auto opacity-25 cursor-pointer"
                                  icon="times"></font-awesome>
                </div>
                <div :class="fullHeight ? `h-full` : ''" class="px-4 mb-4 flex flex-col max-h-64 overflow-y-auto">
                    <slot v-if="isCorrectPIN"></slot>
                    <div v-if="!isCorrectPIN" class="flex flex-col">
                        <p class="text-gray-500 text-sm text-center mt-6">Pre pokračovanie zadajte PIN</p>
                        <div class="ml-auto mr-auto my-6">
                            <input v-cloak
                                   placeholder="0"
                                   v-autofocus
                                   @keypress="pinKeyPress" type="text" name="input1" ref="pincode1"
                                   maxlength="1"
                                   class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                            <input
                                v-cloak
                                placeholder="0"
                                @keypress="pinKeyPress" type="text" name="input2" ref="pincode2"
                                maxlength="1"
                                class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                            <input
                                v-cloak
                                placeholder="0"
                                @keypress="pinKeyPress" type="text" name="input3" ref="pincode3"
                                maxlength="1"
                                class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                            <input
                                v-cloak
                                placeholder="0"
                                @keypress="pinKeyPress" type="text" name="input4" ref="pincode4"
                                maxlength="1"
                                class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                        </div>
                        <p class="text-center text-sm transition"
                           :class="(pinWasFilled && enteredPIN !== pinCode) ? 'text-red-400' : 'text-gray-500'">{{
                            pinWasFilled && (enteredPIN !== pinCode) ? 'Ľutujeme, ale vami zadaný PIN nie je správny' :
                            'Zadajte 4-miestny PIN' }}</p>
                    </div>
                </div>
                <div class="flex items-center px-3 py-2 overflow-hidden transition mt-auto"
                     :class="(showFooter && isCorrectPIN) ? 'h-12 opacity-100' : 'h-0 opacity-0'">
                    <button v-ripple v-if="closeButton" @click="closeMethod"
                            class="ml-auto py-2 px-4 text-gray-400 text-sm">Zatvoriť
                    </button>
                    <button v-ripple v-if="saveButton" @click="saveClick" class="ml-2 py-2 px-4 text-orange-500 text-sm"
                            :class="closeButton ? '' : 'ml-auto'">Uložiť
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "ModalWindow",
        props: {
            onSaveClick: {
                default: (e) => console.log(e.target),
                type: Function,
            },
            onCloseClick: {
                type: Function,
                required: true
            },
            show: {
                default: false,
                type: Boolean,
                required: true
            },
            closeButton: {
                default: true,
                type: Boolean | String
            },
            saveButton: {
                default: true,
                type: Boolean | String
            },
            modalTitle: {
                default: "Modal Title",
                type: String,
            },
            showFooter: {
                default: true,
                type: Boolean
            },
            dissmissable: {
                default: true,
                type: Boolean
            },
            afterOpen: {
                default: () => {},
                type: Function
            },
            size: {
                default: "default",
                type: String
            },
            pinRequired: {
                type: Boolean | String,
                default: false
            },
            pinCode: {
                type: String | Number,
                default: ''
            },
            fullHeight: {
                type: String | Boolean,
                default: false
            }
        },

        data() {
            return {
                pinWasFilled: false,
                enteredPIN: ''
            };
        },
        
        computed: {
            isDismissible() {
                return this.dissmissable;
            },

            isCorrectPIN() {
                if (!this.pinRequired) return true;
                return this.pinWasFilled && this.enteredPIN === this.pinCode.toString();
            },
            
            closeMethod() {
                return this.isDismissible ? this.closeClick : () => {
                }
            },

            modalSize() {
                if(this.size === 'wide')
                    return 'w-5/6 md:w-2/6';

                if(this.size === "wider")
                    return 'w-full md:w-2/4';
                
                return 'w-2/4 md:w-1/4'
            }
        },
        methods: {
            doAfterOpen() {
                this.afterOpen();
            },
            
            closeClick() {
                this.onCloseClick();
                if (this.pinRequired)
                    this.clearPin()
            },
            saveClick() {
                this.onSaveClick();

                if (this.pinRequired)
                    this.clearPin()
            },

            clearPin() {
                this.pinWasFilled = false;
                this.enteredPIN = "";
            },

            pinKeyPress(e) {
                e.preventDefault();
                if (Number.isInteger(parseInt(e.key))) {
                    e.target.value = e.key;
                    if (e.target.name === "input1") {
                        this.$refs.pincode2.focus()
                    } else if (e.target.name === "input2") {
                        this.$refs.pincode3.focus()
                    } else if (e.target.name === "input3") {
                        this.$refs.pincode4.focus()
                    } else {
                        e.target.blur();
                        this.pinWasFilled = (
                                this.$refs.pincode1.value !== ""
                                &&
                                this.$refs.pincode2.value !== ""
                                &&
                                this.$refs.pincode3.value !== ""
                                &&
                                this.$refs.pincode4.value !== ""
                        );
                    }
                    if (this.enteredPIN.length >= 4)
                        this.enteredPIN = "";
                    this.enteredPIN += "" + e.target.value;
                }
            },
        },

        mounted() {
            if(this.show) {
                document.body.style.overflow = 'hidden';
                setTimeout(() => this.doAfterOpen(), 200)
            }else {
                document.body.style.overflow = 'auto';
            }

            let input = document.querySelector('[autofocus]');
            if (input) {
                input.focus()
            }
        },

        watch: {
            show: function(newVal, oldVal) { // watch it
                if(newVal) {
                    document.body.style.overflow = 'hidden';
                    this.doAfterOpen();
                }else {
                    document.body.style.overflow = 'auto';
                }
                
            }
        }
    }
</script>